import { Undo2 } from "lucide-react";

import { Button } from "#/components/ui/button";

interface UndoButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function UndoButton({ onClick, disabled }: UndoButtonProps) {
  return (
    <Button
      type="button"
      variant="accent"
      size="icon-lg"
      onClick={onClick}
      disabled={disabled}
      aria-label="Undo"
    >
      <Undo2 aria-hidden />
    </Button>
  );
}
